import { Component } from '@angular/core';

import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-top',
  templateUrl: './top.component.html',
  styleUrls: ['./top.component.scss'],
  standalone: true,
})
export class TopComponent {
  appVer: string = environment.base.appVersion;

  constructor() {
    console.log("top.ts")
    const o = this;
  }
}
